/**
 * Záložky uvnitř aplikace (jen počítač).
 *
 * Úkol nebo detail klienta otevřený na celou stránku se dřív musel dávat
 * do dalšího okna prohlížeče, takže člověk skákal mezi dvěma adminy a v
 * každém se aplikace načítala zvlášť. Tady je proto vlastní řada záložek: jedna aplikace,
 * víc rozdělaných míst a přepínání jedním klepnutím.
 *
 * Záložka je jen adresa a název. Přepnutí je normální navigace, takže
 * stránka se překreslí z čerstvých dat; drží se to, kde člověk byl, ne
 * rozepsaný formulář. Na telefonu se řada nekreslí, tam je na ni málo
 * místa a přepíná se spodní lištou.
 *
 * Bez Reactu, ať se dá testovat v Node.
 */

export const KLIC = "fw40.taby";
export const KLIC_AKTIVNI = "fw40.taby.aktivni";
/** Víc už se do řady nevejde a přestává to být přehledné. */
export const MAX_TABU = 8;
/** Událost, kterou si stránky říkají o novou záložku. */
export const UDALOST = "fw40-nova-zalozka";

let citac = 0;
/** Nové id. Nezáleží na tvaru, jen ať se neopakuje v rámci běhu. */
export const noveId = () => `t${Date.now().toString(36)}${(citac += 1)}`;

/** Bezpečné načtení uloženého seznamu. Rozbitá data se zahodí. */
export function nactiTaby(raw) {
  try {
    const data = JSON.parse(raw || "null");
    if (!Array.isArray(data)) return [];
    return data
      .filter((t) => t && typeof t.to === "string" && t.to.startsWith("/"))
      .slice(0, MAX_TABU)
      .map((t) => ({ id: String(t.id || noveId()), to: t.to, title: String(t.title || "Admin").slice(0, 60) }));
  } catch {
    return [];
  }
}

/**
 * Přidání záložky. Stejná adresa se neotevírá dvakrát, jen se na ni skočí,
 * stejně jako to dělá prohlížeč s připnutou stránkou.
 */
export function pridej(taby, { to, title }) {
  const uz = taby.find((t) => t.to === to);
  if (uz) return { taby, id: uz.id, uzByla: true };
  if (taby.length >= MAX_TABU) return { taby, id: null, plno: true };
  const zaloz = { id: noveId(), to, title: title || "Admin" };
  return { taby: [...taby, zaloz], id: zaloz.id };
}

/**
 * Zavření záložky. Vrací i to, kam se má aplikace přesunout, když se
 * zavírala ta právě otevřená — na sousední vlevo, jinak vpravo.
 */
export function zavri(taby, id, aktivni) {
  const idx = taby.findIndex((t) => t.id === id);
  if (idx === -1) return { taby, aktivni, kam: null };
  const zbytek = taby.filter((t) => t.id !== id);
  if (id !== aktivni) return { taby: zbytek, aktivni, kam: null };
  const soused = zbytek[idx - 1] || zbytek[idx] || null;
  return { taby: zbytek, aktivni: soused?.id ?? null, kam: soused?.to ?? null };
}

/** Přesun záložky na místo jiné (přetažení myší v řadě). */
export function presun(taby, id, cilId) {
  if (id === cilId) return taby;
  const od = taby.findIndex((t) => t.id === id);
  const kam = taby.findIndex((t) => t.id === cilId);
  if (od === -1 || kam === -1) return taby;
  const dalsi = [...taby];
  const [tab] = dalsi.splice(od, 1);
  dalsi.splice(kam, 0, tab);
  return dalsi;
}

/** Změna adresy v otevřené záložce — chození po aplikaci ji přepisuje. */
export function prepis(taby, id, { to, title }) {
  return taby.map((t) => (t.id === id ? { ...t, to, title: title || t.title } : t));
}
